import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface GetProductCouriersResponse extends Response {
	data: { couriers: Courier[] }
}

export type Courier = {
	no: string
	status: string
	name: string
	code: string
	create_date?: string
	modify_date?: string
}

export const getProductCouriers = async (): Promise<GetProductCouriersResponse> => {
	const response = await client.get<GetProductCouriersResponse>(`/products/couriers`)

	return response.data
}
